import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
import { installGlobalErrorHandlers } from './lib/observability'
import { initAnalytics } from './lib/analytics'
import { initMetaPixel } from './lib/metaPixel'
import { captureReferralFromUrl } from './lib/referral'
import { capturePartnerFromUrl } from './lib/partner'
import { captureAttributionFromUrl } from './lib/attribution'
import { initSentry } from './lib/sentry'

initSentry()
installGlobalErrorHandlers()
initAnalytics()
initMetaPixel()
captureReferralFromUrl()
capturePartnerFromUrl()
captureAttributionFromUrl()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
